import { areDetailedCybusVolumeEquals, Capability, type CybusDetailedVolume } from '../../../../../../domain'

import { BaseSubscriptionStrategy } from '../Base'
import { mapBaseVolume } from './Base'

export class DetailedVolumeStrategy extends BaseSubscriptionStrategy<never, 'volume'> {
    protected override areEquals = areDetailedCybusVolumeEquals

    override readonly requiredPermissions = [Capability.VOLUME_READ]

    override retrieveOne (id: string): Promise<CybusDetailedVolume> {
        return this.request<'/api/volumes/+/inspect', 'GET', CybusDetailedVolume>({
            capability: Capability.VOLUME_READ,
            method: 'GET',
            path: '/api/volumes/+/inspect',
            pathParams: [id],
            authenticate: true,
            handlers: {
                200: (response) => response.getJson().then((data) => ({ ...mapBaseVolume(data), labels: data.Labels })),
                404: DetailedVolumeStrategy.createNotFoundErrorHandler('/api/volumes/+/inspect', id),
            },
        })
    }
}
